module.exports = __webpack_public_path__ + "/public/images/167c47c1f0e437f9b273f4cbce2d8dde.png";